/* ==========================================================================
   LF Outlet, Rieles con flechas
   Cualquier lista marcada con data-lf-riel se envuelve en un marco y recibe
   dos flechas. Aparecen solo cuando hay algo que correr, y cada una se apaga
   al llegar a su extremo. Sin JavaScript el riel se sigue deslizando con el
   dedo, que es como funcionaba antes.
   ========================================================================== */
(function () {
  'use strict';

  var PASO = 0.85; // cuánto del ancho visible avanza cada toque

  function quieto() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function flecha(direccion, etiqueta) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lf-riel__flecha lf-riel__flecha--' + direccion;
    b.setAttribute('aria-label', etiqueta);
    b.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function preparar(riel) {
    if (riel.dataset.lfRielListo === 'si') return;
    riel.dataset.lfRielListo = 'si';

    var marco = document.createElement('div');
    marco.className = 'lf-riel';
    riel.parentNode.insertBefore(marco, riel);
    marco.appendChild(riel);

    var ant = flecha('ant', 'Ver anteriores');
    var sig = flecha('sig', 'Ver más');
    marco.appendChild(ant);
    marco.appendChild(sig);

    function avanzar(signo) {
      riel.scrollBy({
        left: signo * riel.clientWidth * PASO,
        behavior: quieto() ? 'auto' : 'smooth'
      });
    }

    ant.addEventListener('click', function () { avanzar(-1); });
    sig.addEventListener('click', function () { avanzar(1); });

    function actualizar() {
      var max = riel.scrollWidth - riel.clientWidth;
      var hay = max > 8;
      marco.classList.toggle('lf-riel--con-flechas', hay);
      ant.hidden = !hay || riel.scrollLeft <= 4;
      sig.hidden = !hay || riel.scrollLeft >= max - 4;
    }

    var pendiente = false;
    riel.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        actualizar();
      });
    }, { passive: true });

    window.addEventListener('resize', actualizar);
    if ('ResizeObserver' in window) new ResizeObserver(actualizar).observe(riel);

    // las fotos cambian el ancho al cargar
    riel.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', actualizar, { once: true });
    });

    actualizar();
  }

  function iniciar() {
    document.querySelectorAll('[data-lf-riel]').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // el editor de temas vuelve a montar las secciones
  document.addEventListener('shopify:section:load', iniciar);
})();
